import type { ISbStoryData } from '@storyblok/js'
import type { ProductOffer } from '@percent/cause-dashboard/storyblok/types/storyblok-components'

export type NativeApplyModalContext = {
  logoUrl: string
  title: string
  description: string
}

/**
 * Resolves a Storyblok offer relation (`Banner.offer`, `ProductOfferCtaCard.offer`,
 * `NativeApplyModalButton.offer`) into the modal header data.
 *
 * Returns `null` when the relation is unresolved (left as a string id), points to a
 * non-`product_offer` story, or any of `logo.filename` / `title` / `description` is empty.
 * Callers use the `null` to skip rendering the CTA so we never open a modal with missing copy.
 */
export function getResolvedNativeApplyContext(
  ref: ISbStoryData<ProductOffer> | string | undefined | null
): NativeApplyModalContext | null {
  if (!ref || typeof ref !== 'object') {
    return null
  }

  const story = ref as ISbStoryData<ProductOffer>
  if (story.content?.component !== 'product_offer') {
    return null
  }

  const logoUrl = story.content.logo?.filename?.trim() ?? ''
  const title = story.content.title?.trim() ?? ''
  const description = story.content.description?.trim() ?? ''

  if (!logoUrl || !title || !description) {
    return null
  }

  return { logoUrl, title, description }
}
